/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */

'use strict';

import {
    EntityBase,
    ClientProperties
} from "./entitybase";
import * as tools from '../utils/tools';
import { EntityTypes } from "../utils/dvtypes";

class PackageDefinition {
    /**
     * Create new package definition object
     * @class
     * @classdesc Package Definition Object
     */
    constructor () {
        /**
         * Description of the package
         * @type {string|null}
         */
        this.Description = null;

        /**
         * Defined name of the package (package title)
         * @type {string|null}
         */
        this.Name = null;

        /**
         * The version of the application when the package is created/updated
         * @type {string}
         */
        this.ClientVersion = app.version;
    }
}

export class PackageEntity extends EntityBase {
    /**
     * Create new Package entity object
     * @class
     * @classdesc Package Entity Object
     */
    constructor () {
        super();

        /**
         * The initial ID of the package is a negative (temporar) number.
         * @type {number}
         */
        this.PackageID = tools.tempID();

        /**
         * Logical name of the package
         * @type {string}
         */
        this.Name = "";

        /**
         * The base definition of the package.
         * @type {PackageDefinition}
         */
        this.Definition = new PackageDefinition();

        /**
         * Client properties of the package for use in the client.
         * @type {ClientProperties}
         */
        this.clientProperties = new ClientProperties(EntityTypes.Package);
    }
}
